import React, { useCallback } from 'react';
import {
  Flex, Heading, Text, Box, CircularProgress,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useActions, useRedirect, useRole } from '../../util/hooks';
import { logout } from '../../redux/slices/user';
import { RootState } from '../../redux/store';

const version = VERSION;

const Header = () => {
  const { data: { firstName = '' }, isLoggedIn, isFetched } = useSelector(({ user }: RootState) => user);
  const { role } = useRole();
  const logoutAction = useActions(logout, []);
  const { redirect } = useRedirect();

  const handleLogout = useCallback(() => {
    logoutAction();
  }, [logoutAction]);
  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding="0.5rem"
      bg="blue.500"
      color="white"
    >
      <Flex align="center" mr={5}>
        <Heading as="h1" size="lg" onClick={() => redirect('/')} cursor="pointer">
          BCARD
          {' '}
        </Heading>
        {isLoggedIn && isFetched ? (
          <Flex>
            <Text marginX="5">
              {firstName}
            </Text>
            <Text marginX="5">
              (
              {role?.toUpperCase()}
              )
            </Text>
            <Box bg="blue.700" borderRadius="20px" paddingX="3">
              <Text cursor="pointer" onClick={handleLogout}>LOGOUT</Text>
            </Box>

          </Flex>
        ) : <CircularProgress isIndeterminate ml={5} size="20px" color="green" />}
      </Flex>
      {process.env.NODE_ENV}
      {' '}
      v
      {version}
      {' '}
      (
      {process.env.REACT_APP_API_URL}
      )
    </Flex>
  );
};

export default Header;
